import { type Reducer, combineReducers } from 'redux';
import type { OptimisticState } from 'redux-optimistic-ui';
import type { Action } from '../types.tsx';
import { configurationReducer } from './configuration/reducer.tsx';
import entitiesReducers from './entities/reducer.tsx';
import type { EntitiesState } from './entities/types.tsx';
import type { State } from './types.tsx';
import uiReducers from './ui/reducer.tsx';

export default function rootBoardReducer(): Reducer<State, Action> {
	return combineReducers<State, Action>({
		configuration: configurationReducer,
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		entities: entitiesReducers() as Reducer<EntitiesState | OptimisticState<EntitiesState>, Action>,
		ui: uiReducers(),
	});
}
